import Model from "backdraft-app/src/model";

export default class CampaignSelection extends Model {
  get defaults() {
    return {
      status: "all",
      name: ''
    };
  }

  get statuses() {
    return CampaignSelection.statuses;
  }
}

CampaignSelection.statuses = {
  all: "All campaigns",
  active: "All active campaigns",
  paused: "All paused campaigns"
};
